import forge from "node-forge";

const encryptData = (data) => {
  try {
    // Generate AES-256 key (32 bytes)
    const aesKey = forge.random.getBytesSync(32);
    
    // Generate random IV (16 bytes for AES-CBC)
    const iv = forge.random.getBytesSync(16);

    // Encrypt data with AES-256-CBC
    const cipher = forge.cipher.createCipher("AES-CBC", aesKey);
    cipher.start({ iv: iv });
    cipher.update(forge.util.createBuffer(data, "utf8"));
    cipher.finish();
    const encryptedData = forge.util.encode64(cipher.output.getBytes());

    // Get RSA public key from environment
    let publicKeyPem = process.env.REACT_APP_PUBLIC_KEY;
    if (!publicKeyPem) {
      throw new Error("REACT_APP_PUBLIC_KEY not found in environment variables");
    }

    // Ensure proper PEM formatting with newlines
    // First, handle escaped newlines if they exist
    publicKeyPem = publicKeyPem.replace(/\\n/g, '\n');

    // Parse the public key (handles both PKCS#1 and PKCS#8 formats)
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    // Encrypt AES key with RSA public key
    const encryptedAesKey = publicKey.encrypt(aesKey, "RSA-OAEP");
    const encryptedKey = forge.util.encode64(encryptedAesKey);

    // Encrypt IV with RSA public key
    const encryptedIvBytes = publicKey.encrypt(iv, "RSA-OAEP");
    const ivString = forge.util.encode64(encryptedIvBytes);

    // Return in the same format as original code
    return {
      data: encryptedData,
      encryptedKey: encryptedKey,
      iv: ivString,
    };
  } catch (error) {
    console.error("Encryption failed:", error);
    throw error;
  }
};

export default encryptData;
